import {
  faBuilding,
  faMapMarkerAlt,
  faEnvelope,
  faPhone,
  faCity,
  faLeaf,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";

export const getProfileCards = (profile, t) => {
  const cards = [
    {
      icon: faBuilding,
      label: t("Company Name"),
      value: profile?.company_name,
      fullWidth: false,
    },
    {
      icon: faEnvelope,
      label: t("Email"),
      value: profile?.email,
      fullWidth: false,
    },
    {
      icon: faPhone,
      label: t("Phone Number"),
      value: profile?.phone_number,
      fullWidth: false,
    },
    {
      icon: faCity,
      label: t("City"),
      value: profile?.city,
      fullWidth: false,
    },
    {
      icon: faMapMarkerAlt,
      label: t("Address"),
      value: profile?.address,
      fullWidth: true,
    },
  ];

  // add optional fields only if they exist
  if (profile?.lat && profile?.lon) {
    cards.push({
      icon: faGlobe,
      label: t("Coordinates"),
      value: `${profile.lat}, ${profile.lon}`,
      fullWidth: false,
    });
  }

  if (profile?.ghg_rating) {
    cards.push({
      icon: faLeaf,
      label: t("GHG Rating"),
      value: `${profile.ghg_rating} / 5`,
      fullWidth: false,
    });
  }

  return cards;
};
